"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var variantStyles = {
  shadow: (0, _coreSc.css)(["box-shadow:0 0 2px 0 #c5c5c5;"])
};

var Nav = _coreSc.styled.nav.withConfig({
  displayName: "Nav",
  componentId: "sc-9rzhmg-0"
})(["position:relative;z-index:50;height:55px;width:100vw;background:", ";font-family:Colfax,'Helvetica Neue',Helvetica,Arial,sans-serif;", ""], _coreSc.white, function (p) {
  return variantStyles[p.variant];
});

var _default = Nav;
exports["default"] = _default;